/**
 * @desc export
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allolcationTrial.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/AllolcationTrial/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
